import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography} from 'views/components';

import {translate, MarkdownViewer, Translate} from 'views/module';

const CustomDescriptionSection = (props) => {
  const {
    customDescription,
    questions,
    clientName = '',
  } = props;
  const caregiverFirstName = questions.firstName;
  const clientFirstName = clientName.trim().split(' ')[0] || translate('caregiverDetail.CustomDescription.YourLovedOne');

  if (!customDescription) return null;

  return (
    <Stack
      alignItems="flex-start"
      spacing={2}
      width="100%"
      sx={{}}
    >
      <Typography
        variant="body1"
        fontWeight="bold"
        sx={{
          color: '#686868',
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
        }}
      >
        <Translate
          expression="caregiverDetail.CustomDescription.Title"
          substitute={{caregiverFirstName, clientFirstName}}
        />
      </Typography>
      <Stack
        sx={{
          p: 2,
          bgcolor: 'color.white',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'color.divider',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <MarkdownViewer value={customDescription} />
      </Stack>
    </Stack>
  );
};

CustomDescriptionSection.propTypes = {
  customDescription: PropTypes.string,
  questions: PropTypes.object.isRequired,
  clientName: PropTypes.string.isRequired,
};

export default CustomDescriptionSection;
